<script>
  import { tr } from '~/assets/scripts/helpers'

  export default {
    name: 'Tabs',
    provide() {
      return {
        addTab: (tab) => {
          this.tabs.push(tab)
          if (!this.activeTabKey && !tab.ref.disabled) {
            this.activeTabKey = tab.key
          }
        },
        activeTabKey: computed(() => this.activeTabKey),
        setActiveTabKey: (tabKey) => {
          this.activeTabKey = tabKey
        },
        setTabTitle: (tabKey, title) => {
          this.setTabTitle(tabKey, title)
        },
      }
    },
    props: {
      center: { type: Boolean, default: false },
      justify: { type: Boolean, default: false },
      noBorder: { type: Boolean, default: false },
      noPadding: { type: Boolean, default: false },
      vertical: { type: Boolean, default: false },
      bodyClass: { type: String, default: '' },
    },
    emits: ['tabChange'],
    data() {
      return {
        activeTabKey: '',
        tabs: [],
      }
    },
    watch: {
      activeTabKey(newVal, oldVal) {
        if (oldVal !== newVal && oldVal !== '') {
          const idx = this.tabs.findIndex((e) => e.key === newVal)
          this.$emit('tabChange', { index: idx, title: this.tabs[idx].title, key: newVal })
        }
      },
    },
    methods: {
      tr,
      activateTab(tab) {
        if (!tab.ref.disabled) {
          this.activeTabKey = tab.key
        }
      },
      setTabTitle(key, title) {
        const tab = this.tabs.find((e) => e.key === key)
        if (tab) {
          tab.title = title
        }
      },
    },
  }
</script>

<template>
  <div :class="{ card: !noBorder, 'flex-row': vertical }">
    <div class="card-header px-2" :class="vertical ? 'flex-shrink-1' : null">
      <ul
        class="nav nav-pills gap-1"
        :class="{
          'justify-content-between': justify,
          'justify-content-center': center,
          'flex-column': vertical,
        }"
      >
        <li
          v-for="tab in tabs"
          :key="tab.title"
          class="nav-item"
          :class="{
            'cursor-pointer': !tab.ref.disabled,
            'w-auto': center,
            'flex-grow': justify,
          }"
          @click="activateTab(tab)"
        >
          <a
            class="nav-link"
            :class="{ active: tab.key === activeTabKey, disabled: tab.ref.disabled }"
          >
            {{ tab.translate ? tr(tab.title) : tab.title }}
          </a>
        </li>
      </ul>
    </div>
    <div :class="`${bodyClass} ${!noPadding ? 'card-body' : ''} ${vertical ? 'flex-grow-1' : ''}`">
      <slot />
    </div>
  </div>
</template>

<style scoped></style>
